
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/firmware-embedded",
      function () {
        return require("private-next-pages/firmware-embedded.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/firmware-embedded"])
      });
    }
  